module.exports = __webpack_public_path__ + "static/fddxyy-c21fcbab3f2460e98ece1089e67b5592.jpg";